// Pure decisions of the reschedule page (v1's BookingReschedulePanelEntry
// and its view): what is sent, and what the cancel box under the dates says.

export type CrossListing = {
  scope: "same_listing" | "any_listing" | "specific_listings" | string;
  listings: { _id: string; title: string; thumbnail?: string; slug?: string }[];
};

/** The body of POST /widget/pages/bookings/reschedule/:id. `listingId` only
 * when moving to another listing (the API re-checks it against the school's
 * reschedule scope). */
export function reschedulePayload(args: {
  sessionId?: string;
  startDateTime: string;
  listingId: string;
  ownListingId: string;
}): { sessionId?: string; sessionStartDateTime: string; listingId?: string } {
  return {
    ...(args.sessionId ? { sessionId: args.sessionId } : {}),
    sessionStartDateTime: args.startDateTime,
    ...(args.listingId && args.listingId !== args.ownListingId ? { listingId: args.listingId } : {}),
  };
}

/** Whether the "show dates for" listing switch is offered: regular bookings
 * whose school lets them move to other listings. */
export function offersListingSwitch(bookingType: string | undefined, crossListing: CrossListing | null | undefined): boolean {
  return bookingType === "regular" && !!crossListing && crossListing.listings.length > 0;
}

/** The line(s) above "Cancel booking" when the booking can be cancelled, or
 * null when nothing needs saying. */
export function cancelBoxMessage(args: {
  bookingType: string | undefined;
  sessionsCount: number;
  isLoadingSessions: boolean;
  onOtherListing: boolean;
}): string | null {
  const isAppointment = args.bookingType === "anytime";
  if (args.sessionsCount > 0 || isAppointment) {
    return "None of these dates work for you? You can cancel your booking and get a full refund.";
  }
  if (args.isLoadingSessions) return null;
  return args.onOtherListing
    ? "Looks like there aren’t any dates available for your booking on that class. Try another class, or cancel your booking and get a full refund."
    : "Looks like there aren’t any dates left for your ticket type. Does your current date not work for you? If so you can cancel your booking and get a full refund.";
}

/** The class a cross-listing move went to, by id. */
export function listingTitle(crossListing: CrossListing | null | undefined, listingId: string): string | undefined {
  return crossListing?.listings.find((l) => l._id === listingId)?.title;
}
